import styled from 'styled-components';

export const Container = styled.div`
  .panel-box {
    border-radius: 8px;
  }

  .panel-box .material-icons {
    font-size: 18px;
  }

  .panel-stat-label {
    color: ${(props) => props.theme.$gray600};
  }

  .panel-stat-value,
  .panel-title,
  .panel-item-title {
    color: ${(props) => props.theme.$dark};
  }

  .panel-stat-value {
    font-size: clamp(1.2rem, 1.1vw, 1.6rem);
    line-height: 1.2;
  }

  .panel-shortcut {
    text-align: left;
    font-size: 14px;
    color: ${(props) => props.theme.$dark};
    transition: box-shadow 0.15s ease;
  }

  .panel-shortcut:hover {
    box-shadow: 0 2px 8px ${(props) => props.theme.$black}14;
  }

  .panel-shortcut-info {
    min-width: 0;
  }

  .panel-note {
    background: ${(props) => props.theme.$gray200};
    padding: 10px 16px;
  }

  .panel-note-author {
    color: ${(props) => props.theme.$dark_slate_blue};
    min-width: 0;
  }

  .panel-note-message,
  .panel-message,
  .panel-date {
    color: ${(props) => props.theme.$gray900};
  }

  .panel-date {
    font-size: 13px;
  }

  .panel-item,
  .panel-message {
    border-radius: 6px;
    background: ${(props) => props.theme.$white};
  }

  .panel-item-icon {
    width: 48px;
    height: 48px;
    background: ${(props) => props.theme.$gray200};
    color: ${(props) => props.theme.$gray600};
  }

  .panel-item-icon .material-icons {
    font-size: 24px;
  }

  .panel-count {
    padding: 0 6px;
    color: ${(props) => props.theme.$gray700};
  }

  .panel-count .material-icons {
    font-size: 14px;
  }

  .min-width-0 {
    min-width: 0;
  }
`;
